import React, { useEffect, useRef, useState } from 'react';
import * as THREE from 'three'

export default function Marker({ data, username }) {

  const sceneRef = useRef(null);
  const minUrl = `${process.env.REACT_APP_SERVER}/uploads/${username}/mind/${data.mind}`
  const imageTarget = "imageTargetSrc: " + minUrl + "; maxTrack: 1; autoStart: false; uiLoading: yes; uiError: yes; uiScanning: yes; filterMinCF: 0; filterBeta: 0.5; warmupTolerance: 1; missTolerance: 1"



  var videoUrl = data.video;
  var voiceUrl = data?.voice;

  var positonPlay = `${0} ${0} ${0.01}`
  // var positonFullscreen = (widthD, heightD) => { return `${0.45} -${(getSize(widthD, heightD).height / 2) + 0.07} ${0.0035}` };
  var postionIndex = 0;

  const positonContact = (widthD, heightD) => {
    var posArray = [
      `${-0.45} -${(getSize(widthD, heightD).height / 2) + 0.07} ${0.0035}`,
      `${-0.30} -${(getSize(widthD, heightD).height / 2) + 0.07} ${0.0035}`,
      `${-0.15} -${(getSize(widthD, heightD).height / 2) + 0.07} ${0.0035}`,
      `${0.0} -${(getSize(widthD, heightD).height / 2) + 0.07} ${0.0035}`
    ]

    const fin = posArray[postionIndex]
    postionIndex++;
    return fin;
  }

  const getSize = (widthD, heightD) => {

    var w = widthD;
    var h = heightD;
    var width = 1;
    var height = 1;

    if (w > h) {
      height = h / w;
    }

    if (h > w) {
      height = h / w;
    }

    return { width: width, height: height }

  }

  const getModel = (modelName) => {
    return `${process.env.REACT_APP_SERVER}/uploads/${username}/3d_model/${modelName}`
  }

  var EmbedVideo = function (props) {
    return (
      <video src={`${process.env.REACT_APP_SERVER}/uploads/${username}/video/${videoUrl[props.index]}`} id={props.videoId} autoPlay={false} playsInline webkit-playsinline="true" crossOrigin="anonymous" preload="metadata" loop={true}>
        <source src={`${process.env.REACT_APP_SERVER}/uploads/${username}/video/${videoUrl[props.index]}`} type={`video/${videoUrl[props.index].split('.')[1]}`} />
        Your browser does not support the video tag.
      </video>
    )
  }

  var EmbedVoice = function (props) {
    return voiceUrl[props.index] ? (
      <audio
        className="hidden"
        id={props.voiceId}
        src={`${process.env.REACT_APP_SERVER}/uploads/${username}/voice/${voiceUrl[props.index]}`}
        autoPlay={false}
        playsInline
        webkit-playsinline="true"
        crossOrigin="anonymous"
        preload="auto"
        loop
      >
        <source
          src={`${process.env.REACT_APP_SERVER}/uploads/${username}/voice/${voiceUrl[props.index]}`}
          type={`audio/${voiceUrl[props.index].split('.')[1]}`}
        />
        Your browser does not support the audio tag.
      </audio>
    ) : (<></>)
  }

  function visibleModel(index) {
    const model = document.querySelector(`#model_visible_${index}`);
    if (model) {
      console.log("model_visible_");
      
      model.setAttribute("visible", true);
    }
  }

  function playVideo(index) {
    const exampleTarget = document.getElementById(`place_target_${index}`);
    exampleTarget.addEventListener("targetFound", event => {
      const playButton = document.querySelector(`#play_button_${index}`);
      const res = playButton.getAttribute("visible");
      if (!res) {
        var video = document.getElementById(`videoNFT_${index}`);
        if (video) {
          video.play()
        }
      }
    });
  }

  function playVoice(index) {
    const exampleTarget = document.getElementById(`place_target_${index}`);
    exampleTarget.addEventListener("targetFound", event => {
      const playButton = document.querySelector(`#play_button_${index}`);
      const res = playButton.getAttribute("visible");
      if (!res) {
        if (data?.voice && data?.voice[index] != null) {
          var voice = document.getElementById(`voiceNFT_${index}`);
          if (voice) {
            voice.play()
          }
        }
      }
    });
  }



  function stopVideo(index) {
    const exampleTarget = document.getElementById(`place_target_${index}`);
    exampleTarget.addEventListener("targetLost", event => {
      var video = document.getElementById(`videoNFT_${index}`);
      if (video) {
        video.pause()
      }
    });
  }

  function stopVoice(index) {
    const playButton = document.querySelector(`#play_button_${index}`);
    const res = playButton.getAttribute("visible");
    if (res) {
      const exampleTarget = document.getElementById(`place_target_${index}`);
      exampleTarget.addEventListener("targetLost", event => {
        if (data?.voice && data?.voice[index] != null) {
          var voice = document.getElementById(`voiceNFT_${index}`);
          if (voice) {
            voice.pause()
          }
        }
      });
    }
  }

  function pauseVideo(index) {
    var video = document.getElementById(`videoNFT_${index}`);
    if (video) {
      video.pause()
    }
  }

  function pauseVoice(index) {
    if (data?.voice && data?.voice[index] != null) {
      var voice = document.getElementById(`voiceNFT_${index}`);
      if (voice) {
        voice.pause()
      }
    }
  }

  function contactAction(index) {
    if (data.site) {
      const siteButton = document.querySelector(`#site_button_${index}`);
      siteButton.addEventListener("click", event => {
        pauseVideo(index)
        pauseVoice(index)
        window.open(data.site, '_blank');
      });
    }
    if (data.hint) {
      const hintButton = document.querySelector(`#hint_button_${index}`);
      hintButton.addEventListener("click", event => {
        pauseVideo(index)
        pauseVoice(index)
        window.open(data.hint, '_blank');
      });
    }
    if (data.instagram) {
      const instagramButton = document.querySelector(`#instagram_button_${index}`);
      instagramButton.addEventListener("click", event => {
        pauseVideo(index)
        pauseVoice(index)
        window.open(`https://instagram.com/${data.instagram}`, '_blank');
      });
    }
    if (data.call) {
      const callButton = document.querySelector(`#call_button_${index}`);
      callButton.addEventListener("click", event => {
        pauseVideo(index)
        pauseVoice(index)
        window.open(`tel:${data.call}`, '_blank');
      });
    }
  }

  function iconSound(index) {
    // const imageSound = document.getElementById(`image_${index}`);
    const playButton = document.getElementById(`play_button_${index}`);
    // imageSound.addEventListener("click", event => {
    //   imageSound.addEventListener("click", function () { alert("Hello World! " + index); });

    //   var video = document.getElementById(`videoNFT_${index}`);
    //   video.play()
    //   video.muted = false
    //   if (data?.voice && data?.voice[index] != null) {
    //     var voice = document.getElementById(`voiceNFT_${index}`);
    //     voice.play()
    //     voice.muted = false
    //   }
    //   playButton.setAttribute('visible', false);
    // });

    playButton.addEventListener("click", async (event) => {
      // Debugging: Check button and media presence

      if (videoUrl[index]) {
        const video = document.getElementById(`videoNFT_${index}`);
        if (video) {
          video.muted = false;
          video.play().catch(err => console.error("Error playing video:", err));
        }
      } else {
        visibleModel(index)
      }

      if (data?.voice && data?.voice[index] != null) {
        var voice = document.getElementById(`voiceNFT_${index}`);
        if (voice) {
          voice.play()
          voice.muted = false;
        }
      }

      viewAR();
      playButton.setAttribute("visible", false);
    });

  }

  // function fullscreenAction(index) {
  //   const fullscreenButton = document.querySelector(`#fullscreen_button_${index}`);
  //   fullscreenButton.addEventListener("click", event => {
  //     var elem = document.getElementById(`videoNFT_${index}`);

  //     if (document.fullscreenElement) {
  //       document.exitFullscreen();
  //     } else if (document.webkitFullscreenElement) {
  //       // Need this to support Safari
  //       document.webkitExitFullscreen();
  //     } else if (elem.webkitRequestFullscreen) {
  //       // Need this to support Safari
  //       elem.webkitRequestFullscreen();
  //     } else {
  //       elem.requestFullscreen();
  //     }


  //     // if (elem.requestFullscreen) {
  //     //   elem.requestFullscreen();
  //     // } else if (elem.mozRequestFullScreen) {
  //     //   elem.mozRequestFullScreen();
  //     // } else if (elem.webkitRequestFullscreen) {
  //     //   elem.webkitRequestFullscreen();
  //     // } else if (elem.msRequestFullscreen) {
  //     //   elem.msRequestFullscreen();
  //     // }
  //   });
  // }

  async function viewAR() {

    var body = {
      id: data._id
    };

    await fetch(`${process.env.REACT_APP_SERVER}/api/nft/view/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
  }

  useEffect(() => {

    videoUrl.map((elem, index) => {
      if (elem != null) {
        playVideo(index)
        stopVideo(index)
        if (voiceUrl && voiceUrl[index] != null) {
          playVoice(index)
          stopVoice(index)
        }
        iconSound(index)
      } else {
        if (voiceUrl && voiceUrl[index] != null) {
          playVoice(index)
          stopVoice(index)
        }
        iconSound(index)
      }
      // fullscreenAction(index)
    })
    if (data.site || data.hint || data.instagram || data.call) { //|| data.instagram
      contactAction(0)
    }


    const sceneEl = sceneRef.current;
    const arSystem = sceneEl.systems["mindar-image-system"];
    sceneEl.addEventListener('renderstart', () => {
      arSystem.start(); // start AR 
    });
    return () => {
      arSystem.stop();
    }
  }, []);


  function getDPI() {
    const standardDPI = 96; // Assume 96 DPI for standard screens
    const devicePixelRatio = window.devicePixelRatio || 1; // Get the device's pixel ratio (1 for standard, 2 for Retina, etc.)
    // Adjust the DPI dynamically based on the device's pixel ratio
    return standardDPI * devicePixelRatio;
  }


  return (
    <>

      <div className='relative'>
        <div className='absolute flex items-stretch w-full h-[50px] bg-opacity-40 bg-black text-white text-center '>
          <p className='m-auto'>{data.user.name}</p>
        </div>
      </div>


      <a-scene ref={sceneRef} mindar-image={imageTarget} color-space="sRGB" embedded renderer="colorManagement: true, physicallyCorrectLights" vr-mode-ui="enabled: false" device-orientation-permission-ui="enabled: false">
        <a-assets>
          {videoUrl.map((elem, index) => {
            // const playButton = document.querySelector(`#play_button_${index}`);
            // const res = playButton.getAttribute("visible");

            return (
              <React.Fragment key={index}>
                {
                  <>
                    {elem != null && <EmbedVideo videoId={`videoNFT_${index}`} index={index} />}
                    {elem == null && <a-asset-item visible={true} id={`model_${index}`} src={getModel(data.glb_model[index])}></a-asset-item>}
                    <EmbedVoice voiceId={`voiceNFT_${index}`} index={index} />
                    <img
                      id={`play_${index}`}
                      crossOrigin="anonymous"
                      className='newSound'
                      src={`${process.env.REACT_APP_ADDRESS}/contact/play.png`}
                    />
                  </>
                }
                {index === 0 && (
                  <>
                    {data.site && (<img id={`site_${index}`} crossOrigin="anonymous" className='contact-camera' src={process.env.REACT_APP_ADDRESS + "/contact/site.png"} />)}
                    {data.hint && (<img id={`hint_${index}`} crossOrigin="anonymous" className='contact-camera' src={process.env.REACT_APP_ADDRESS + "/contact/hint.png"} />)}
                    {data.instagram && (<img id={`instagram_${index}`} crossOrigin="anonymous" className='contact-camera' src={process.env.REACT_APP_ADDRESS + "/contact/instagram.png"} />)}
                    {data.call && (<img id={`call_${index}`} crossOrigin="anonymous" className='contact-camera' src={process.env.REACT_APP_ADDRESS + "/contact/call.png"} />)}
                  </>
                )}
              </React.Fragment>
            )
          })}
        </a-assets>
        <a-camera position="0 0 0" look-controls="enabled: false" cursor="fuse: false; rayOrigin: mouse;" raycaster="far: 1000000000; objects: .clickable"></a-camera>

        {videoUrl.map((elem, index) => {

          const size = data.size_model && data.size_model[index];
          const scale = size && size.scale || 0
          const posX = size && size.position && size.position.x || 0
          const posY = size && size.position && size.position.y || 0
          const posZ = size && size.position && size.position.z || 0

          const rotation = size && new THREE.Euler(size.rotation.x, size.rotation.y, size.rotation.z, 'XYZ') || new THREE.Euler(0, 0, 0, 'XYZ');
          // Convert radians to degrees for A-Frame
          const rotX = size && rotation.x * THREE.MathUtils.RAD2DEG || 0;
          const rotY = size && rotation.y * THREE.MathUtils.RAD2DEG || 0;
          const rotZ = size && rotation.z * THREE.MathUtils.RAD2DEG || 0;

          return (
            <React.Fragment key={index}>
              <a-entity mindar-image-target={`targetIndex: ${index}`} id={`place_target_${index}`}  >
                <a-plane
                  src={`#play_${index}`}
                  id={`play_button_${index}`}
                  material="transparent:true"
                  color="#fff"
                  class="clickable"
                  position={positonPlay}
                  height="0.25"
                  width="0.25"
                  rotation="1 0 0"
                />

                {elem == null ?
                  (
                    <a-gltf-model
                      id={`model_visible_${index}`}
                      visible={false}
                      rotation={`${rotX} ${rotY} ${rotZ}`}
                      position={`${posX * (getDPI() * 0.001)} ${-posZ * (getDPI() * 0.001)} ${posY * (getDPI() * 0.001)}`}
                      scale={`${scale * (getDPI() * 0.001)} ${scale * (getDPI() * 0.001)} ${scale * (getDPI() * 0.001)}`}
                      src={`#model_${index}`}
                      animation-mixer="loop: repeat; clampWhenFinished: true;"
                    />
                  )
                  : (
                    <a-plane
                      src={`#videoNFT_${index}`}
                      id={`image_${index}`}
                      position="0 0 0"
                      width={getSize(data.width[index], data.height[index]).width}
                      height={getSize(data.width[index], data.height[index]).height}
                      rotation="0 0 0"
                    />
                  )}
                {index === 0 && (
                  <>
                    {data.site && (<a-plane src={`#site_${0}`} id={`site_button_${0}`} material="transparent:true" color="#fff" class="clickable" position={positonContact(data.width[0], data.height[0])} height="0.10" width="0.10" rotation="1 0 0"></a-plane>)}
                    {data.hint && (<a-plane src={`#hint_${index}`} id={`hint_button_${index}`} material="transparent:true" color="#fff" class="clickable" position={positonContact(data.width[index], data.height[index])} height="0.10" width="0.10" rotation="1 0 0"></a-plane>)}
                    {data.instagram && (<a-plane src={`#instagram_${index}`} id={`instagram_button_${index}`} material="transparent:true" color="#fff" class="clickable" position={positonContact(data.width[index], data.height[index])} height="0.10" width="0.10" rotation="1 0 0"></a-plane>)}
                    {data.call && (<a-plane src={`#call_${index}`} id={`call_button_${index}`} material="transparent:true" color="#fff" class="clickable" position={positonContact(data.width[index], data.height[index])} height="0.10" width="0.10" rotation="1 0 0"></a-plane>)}
                  </>
                )}
              </a-entity>
            </React.Fragment>
          )
        })}
      </a-scene>
    </>
  )
}

